// Authentication utility functions

export const setUserLoggedIn = (userData) => {
  try {
    localStorage.setItem("userLoggedIn", "true");
    if (userData) {
      localStorage.setItem("userData", JSON.stringify(userData));
    }
    window.dispatchEvent(new CustomEvent("wireoxAuthChanged"));
  } catch (error) {
    console.error("Error saving login status:", error);
  }
};

export const isUserLoggedIn = () => {
  try {
    const loggedIn = localStorage.getItem("userLoggedIn");
    return loggedIn === "true";
  } catch (error) {
    console.error("Error reading login status:", error);
    return false;
  }
};

export const getUserData = () => {
  try {
    const userData = localStorage.getItem("userData");
    return userData ? JSON.parse(userData) : null;
  } catch (error) {
    console.error("Error reading user data:", error);
    return null;
  }
};

/**
 * True if any common email/username field on stored user matches (case-insensitive).
 * Used after email confirmation so we update the right session even if only UserName is set.
 */
export const storedUserEmailMatches = (userData, email) => {
  if (!userData || email == null || String(email).trim() === "") return false;
  const want = String(email).trim().toLowerCase();
  const candidates = [
    userData.email,
    userData.Email,
    userData.UserName,
    userData.userName,
  ];
  return candidates.some(
    (c) => c != null && String(c).trim().toLowerCase() === want,
  );
};

/**
 * Login response field IsUserEmailAddressVerified: true means verified.
 * null / false / missing (when logged in) => not verified.
 * When not logged in, verification does not apply (checkout may proceed as guest).
 */
export const isUserEmailVerified = () => {
  if (!isUserLoggedIn()) return true;
  const data = getUserData();
  if (!data) return false;
  const v = data.IsUserEmailAddressVerified;
  if (v === null || v === undefined) return false;
  if (v === true || v === 1 || v === "1") return true;
  if (v === false || v === 0 || v === "0") return false;
  if (typeof v === "string" && v.toLowerCase() === "true") return true;
  if (typeof v === "string" && v.toLowerCase() === "false") return false;
  return false;
};

export const logout = () => {
  try {
    localStorage.removeItem("userLoggedIn");
    localStorage.removeItem("userData");
    window.dispatchEvent(new CustomEvent("wireoxAuthChanged"));
  } catch (error) {
    console.error("Error logging out:", error);
  }
};

